import classNames from "classnames";
import styles from "./GroupRemoveItem.module.scss";

interface GroupFormFieldsProps {
    ariaLabel: string;
    testId: string;
    removeItem: () => void;
}

export const GroupRemoveItem = ({ ariaLabel, testId, removeItem }: GroupFormFieldsProps) => (
    <button
        type="button"
        className={classNames("ancBtn sml silver noBorder", styles.button)}
        data-testid={testId}
        onClick={removeItem}
        aria-label={ariaLabel}
    >
        <span aria-hidden="true" className={classNames("icon iconRemove", styles.icon)} />
    </button>
);
